import * as t from 'io-ts';
import { decode } from '../../../server/lib/codec';

const validateUserProvidedEmailModelV = t.type({
  data: t.type({
    validateEmailUserPrefsDeliveryInstructions: t.type({
      isValid: t.boolean,
    }),
  }),
});

// FIXME: Call using apollo client
const validateUserProvidedEmail = async (params: {
  email: string;
  trackingNumber: string;
  carrier: string;
  retailer: string;
  orderNumber: string;
}) => {
  const { LOMA_URL } = process.env;

  if (!LOMA_URL) throw new Error('Expected LOMA_URL to be defined');

  const body = {
    operationName: null,
    query: `query {
      validateEmailUserPrefsDeliveryInstructions(
        carrier: "${params.carrier}"
        orderNumber: "${params.orderNumber}"
        retailer: "${params.retailer}"
        trackingNumber: "${params.trackingNumber}"
        userProvidedEmail: "${params.email}"
      ) {
        isValid
      }
    }`,
    variables: {},
  };

  const response = await fetch(LOMA_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (response.status >= 500) {
    throw new Error('An unrecoverable error occurred calling the server.');
  }

  const data: unknown = await response.json();
  const json = decode(validateUserProvidedEmailModelV, data);

  const { isValid } = json.data.validateEmailUserPrefsDeliveryInstructions;

  return isValid;
};

export default validateUserProvidedEmail;
